// Copyright © 2021 Move Closer
import { abstractIconProps } from '../../_abstract';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const bootstrapIconProps = abstractIconProps;
